import {TokenService as Service} from '../TokenService';

import {useDialogCrup} from '../../../../shared/hooks/DialogCrup';
import {useTranslation} from '../../../../shared/language';

export const ChangePassword = ({header, dataKey, refreshLazyData}) => {
  const {t} = useTranslation();

  const {render, update} = useDialogCrup({
    header,
    dataKey,
    width: '40rem',
    fields: [
      {field: 'passwordCer', header: t('common.currentPassword'), required: true, InputTextProps: {maxLength: 50, type: 'password'}, className: 'md:col-12'},
      {field: 'newPassword', header: t('common.newPassword'), required: true, InputTextProps: {maxLength: 50, type: 'password'}, className: 'md:col-12'},
      {field: 'newPasswordConfirm', header: t('common.confirmPassword'), required: true, InputTextProps: {maxLength: 50, type: 'password'}, className: 'md:col-12'}
    ],
    updateItem: (id, item) => {
      item.id = id;
      return Service.changePass(item);
    },
    refreshLazyData
  });

  return {render, open: update};

}
